import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.jsx';
import { DEFAULT_AUTHENTICATED_ROUTE } from '../config/routes.js';

// Rota coringa (path="*"): sem ela, qualquer URL desconhecida renderizava uma
// tela em branco — no app nativo isso é lido pelo usuário como crash.
export default function NotFoundPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center relative overflow-hidden bg-background p-4">
      <div className="fixed top-[-20%] left-[-10%] w-[60vw] h-[60vw] rounded-full bg-primary-container/5 blur-[120px] pointer-events-none"></div>
      <div className="fixed bottom-[-20%] right-[-10%] w-[50vw] h-[50vw] rounded-full bg-primary-container/5 blur-[100px] pointer-events-none"></div>

      <main className="relative z-10 w-full max-w-md px-6 py-12 flex flex-col items-center text-center">
        <img
          alt="CatholicGPT Logo"
          className="h-16 w-16 rounded-full bg-white object-contain p-2 shadow-sm mb-6 opacity-80"
          src="/logo-192.png"
        />
        <div className="w-full glass-panel rounded-xl border border-outline-variant/20 shadow-2xl p-8">
          <h1 className="font-headline text-2xl font-bold text-on-surface mb-3">Página não encontrada</h1>
          <p className="text-sm text-on-surface-variant mb-6">
            O endereço que você tentou abrir não existe ou foi movido.
          </p>
          <div className="flex flex-col gap-3">
            <button
              onClick={() => navigate(isAuthenticated ? DEFAULT_AUTHENTICATED_ROUTE : '/', { replace: true })}
              className="w-full bg-primary text-on-primary font-bold rounded-lg py-3 hover:bg-primary-fixed transition-colors"
            >
              Voltar ao início
            </button>
            <button
              onClick={() => navigate(isAuthenticated ? '/chat' : '/login', { replace: true })}
              className="w-full bg-surface-container-highest text-on-surface font-medium rounded-lg py-3 hover:bg-surface-variant transition-colors"
            >
              Ir para o chat
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
